$(function () {
    var $swatchCollection = {
        collection_items: $('#SwatchCollection .swatch-collection .swatch-item'),
        colorDictionary: null
    };

    // Charger le dictionnaire de couleurs
    async function loadColorDictionary() {
        try {
            const colorJsonUrl = document.getElementById('color-json-url')?.value;
            if (!colorJsonUrl) return null;
            
            const response = await fetch(colorJsonUrl);
            if (!response.ok) throw new Error('Erreur de chargement du dictionnaire');
            
            const dictionary = await response.json();
            return dictionary;
        } catch (error) {
            console.error('Erreur lors du chargement du dictionnaire:', error);
            return null;
        }
    }
// Ajoute ce code après l'initialisation des autres gestionnaires d'événements
// mais avant la fin de la fonction initFilters()

// Gestionnaire pour le bouton "Apply Filters"
$(document).on('click', 'button.apply-filters-btn', (e) => {
  e.preventDefault();
  
  // Déclenche artificiellement le filtrage en simulant un clic sur une case cochée
  // ou en appliquant directement le filtrage
  const anyChecked = $('input[name="color"]:checked, input[name="fabric-check"]:checked, input[name="fabric"]:checked').first();
  
  if (anyChecked.length) {
    // Si au moins une case est cochée, simuler un clic dessus pour déclencher le filtrage
    anyChecked.trigger('click').trigger('click');
  } else {
    // Sinon, montrer tous les swatches
    $swatchCollection.collection_items.fadeIn('slow');
    $('.also-available').hide();
    $('.no-result-found').hide();
  }
  
  // Fermer le drawer
  closeDrawer();
  
  // Faire défiler vers le haut de la collection (optionnel)
  $('html, body').animate({
    scrollTop: $('#SwatchCollection').offset().top - 100
  }, 500);
});

    // Filtrage amélioré avec dictionnaire
    async function initFilters() {
        // Charger le dictionnaire
        
        $swatchCollection.colorDictionary = await loadColorDictionary();
        
        $('.custom-checkbox').on('click', function () {
            $(this).parent().find('input[type=checkbox]').click();
        });

        $('input[type=checkbox]').click(function () {
            var selectedColors = [];
            var selectedFabrics = [];
            
            $('input[name="color"]:checked').each(function() {
                selectedColors.push($(this).val().toLowerCase());
            });
            
            // Récupérer tous les tissus sélectionnés
            $('input[name="fabric-check"]:checked, input[name="fabric"]:checked').each(function() {
                selectedFabrics.push($(this).val().toLowerCase());
            });
            
            // 2. Filtrer les swatches
            $('#SwatchCollection .swatch-collection .swatch-item').each(function() {
                var $item = $(this);
                var itemColor = $item.attr('data-color').toLowerCase();
                var itemFabric = $item.attr('data-fabric').toLowerCase();

                var showItem = true;
                
                // Si des couleurs sont sélectionnées, l'item doit correspondre
                if (selectedColors.length > 0) {
                    var colorMatch = false;
                    
                    // Vérifier correspondance directe
                    if (selectedColors.includes(itemColor)) {
                        colorMatch = true;
                    } 
                    else if ($swatchCollection.colorDictionary && $swatchCollection.colorDictionary[itemColor]) {

                        const baseColors = $swatchCollection.colorDictionary[itemColor].base || [];
                        for (const baseColor of baseColors) {
                            if (selectedColors.includes(baseColor.toLowerCase())) {
                                colorMatch = true;
                                break;
                            }
                        }
                    }
                    
                    if (!colorMatch) {
                        showItem = false;
                    }
                }
                
                // Si des tissus sont sélectionnés, l'item doit correspondre
                if (showItem && selectedFabrics.length > 0) {
                    if (!selectedFabrics.includes(itemFabric)) {
                        showItem = false;
                    }
                }
                
                // Afficher ou cacher en fonction du résultat
                if (showItem) {
                    $item.fadeIn('slow');
                } else {
                    $item.fadeOut();
                }
            }).promise().done(function() {
                // Vérifier si des résultats sont visibles
                if ($('.swatch-item').is(':visible') == false) {
                    $('.no-result-found').show();
                } else {
                    $('.no-result-found').hide();
                }
            });
            
            // Si aucun filtre n'est sélectionné, tout montrer
            if (selectedColors.length === 0 && selectedFabrics.length === 0) {
                $swatchCollection.collection_items.fadeIn('slow');
                $('.also-available').hide();
                $('.no-result-found').hide();
            }
        });
        
    }

    // Initialisation
    $('.also-available').hide();
    initFilters();
});
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.collapsible-label').forEach(function (btn) {
      // Supprime les écouteurs existants pour éviter les doublons
      btn.removeEventListener('click', toggleCollapsible);
      // Ajoute le nouvel écouteur
      btn.addEventListener('click', toggleCollapsible);
    });

    function toggleCollapsible() {
      const content = document.getElementById(this.getAttribute('aria-controls'));
      if (!content) return;

      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      content.setAttribute('aria-hidden', expanded);
      content.classList.toggle('active', !expanded);
    }
  });

    $(document).on('click', 'button.open-refine-section', () =>
      openDrawer('.filter-refine-section')
    );
    $(document).on('click', 'button.open-filters-section', () =>
      openDrawer('.filter-section')
    );
    $(document).on('click', 'button#close-drawer-btn', () =>
      closeDrawer()
    );

    function openDrawer(selector) {
      $('#shopify-section-header').addClass('hide-header');
      $(selector).addClass('show-section');
      $('.grid__item--sidebar').addClass('open-drawer');
      $('html, body').addClass('sidebar-open');
      $('#zsiq_float').hide();
    }

    function closeDrawer() {
      $('#shopify-section-header').removeClass('hide-header');
      $('.filter-refine-section, .filter-section').removeClass('show-section');
      $('.grid__item--sidebar').removeClass('open-drawer');
      $('html, body').removeClass('sidebar-open');
      $('#zsiq_float').css('display', 'inline-block');
    }